import XLSX from 'xlsx';
import { IDetalhamentoErro } from '../../../models/escala.erros.model';
import { TipoImportacaoEnum, ColunasArquivoImportacao } from '../../../enums/importacao';
import { applyNsjTableInlineMobileLabels, buildNsjTableInlineMobileLabel } from '../../../../../../utils/nsj-table';


export class MeurhEscalaErrosImportacaoModalController {
    static $inject = ['$uibModalInstance', 'entity', 'tipoImportacao'];

    public fields: ReturnType<typeof applyNsjTableInlineMobileLabels> = [];

    constructor(
        public $uibModalInstance: ng.ui.bootstrap.IModalInstanceService,
        public entity: IDetalhamentoErro[],
        public tipoImportacao: string
    ) {
        this.fields = applyNsjTableInlineMobileLabels(this.setFields());
    }

    setFields() {
        const nonFolgaFields = this.tipoImportacao !== TipoImportacaoEnum.FOLGA ? [
            {
                value: 'dataFim',
                label: 'Data final',
                type: 'string',
                style: 'default',
                copy: '',
            }, {
                value: 'solicitacao.nome',
                label: 'Solicitação',
                type: 'string',
                style: 'default',
                copy: '',
                customLabelHtml: () => {
                    const solicitacaoLabel = this.tipoImportacao?.charAt(0).toUpperCase() + this.tipoImportacao?.slice(1);
                    return buildNsjTableInlineMobileLabel(solicitacaoLabel)();
                },
            }, {
                value: 'empresa.razaosocial',
                label: 'Empresa',
                type: 'string',
                style: 'default',
                copy: '',
            }
        ] : [];

        const folgaFields = this.tipoImportacao === TipoImportacaoEnum.FOLGA ? [
            {
                value: 'estabelecimento.nomefantasia',
                label: 'Estabelecimento',
                type: 'string',
                style: 'default',
                copy: '',
            }
        ] : [];

        return [
            {
                value: 'linha',
                label: 'Linha',
                type: 'string',
                style: 'title',
                copy: '',
            }, {
                value: 'colaborador.nome',
                label: 'Colaborador',
                type: 'string',
                style: 'default',
                copy: '',
            }, {
                value: 'data',
                label: 'Data',
                type: 'string',
                style: 'default',
                copy: '',
                customLabelHtml: () => {
                    const dataLabel = this.tipoImportacao === TipoImportacaoEnum.FOLGA ? 'Data' : 'Data inicial';
                    return buildNsjTableInlineMobileLabel(dataLabel)();
                },
            },
            ...nonFolgaFields,
            ...folgaFields,
            {
                value: 'descricao',
                label: 'Descrição',
                type: 'string',
                style: 'default',
                copy: '',
            },
        ];
    }

    download() {
        // constroi a planilha com as colunas de
        // identificador, data, solicitacao (se precisar de guid) e descricao do erro
        const data = this.entity.map((event) => {
            return {
                identificador: event.importacao?.identificador,
                [ColunasArquivoImportacao[this.tipoImportacao].data]: event.data,
                ...((this.tipoImportacao !== TipoImportacaoEnum.FOLGA) && {
                    [ColunasArquivoImportacao[this.tipoImportacao].dataFinal]: event.dataFim,
                    [this.tipoImportacao]: event.importacao?.[this.tipoImportacao],
                    empresa: event.importacao?.empresa,
                }),
                ...((this.tipoImportacao === TipoImportacaoEnum.FOLGA && event.importacao?.estabelecimento) && {
                    estabelecimento: event.importacao?.estabelecimento,
                }),
                ...((this.tipoImportacao === TipoImportacaoEnum.FOLGA && event.importacao?.descricao) && {
                    descricao: event.importacao?.descricao,
                }),
                descricao_erro: event.descricao
            };
        });

        this.exportToExcel(data, 'Erros', 'escala_erros_importacao.xlsx');
    }

    close() {
        this.$uibModalInstance.dismiss('fechar');
    }

    private exportToExcel(data: any[], sheetName: string, fileName: string) {
        const worksheet = XLSX.utils.json_to_sheet(data);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, sheetName);

        const wbout = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
        const excelBlob = new Blob([wbout], {
            type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
        });

        const downloadLink = document.createElement('a');
        downloadLink.setAttribute('download', fileName);
        downloadLink.setAttribute('href', window.URL.createObjectURL(excelBlob));
        downloadLink.click();
    }
}
